import React from 'react';
import * as Select from '@radix-ui/react-select';
import clsx from 'clsx';
import {useMatches} from '@remix-run/react';

//domains
import {loader} from '~/root';
import {sortingOptions, sortingOptionsZH} from '~/domains/collections';
import {I18nLocale} from '~/lib/type';
import {useNavigate, useLocation} from '@remix-run/react';

export default function CollectionSorting() {

  const [root] = useMatches();
  const selectedLocale = root.data.selectedLocale as I18nLocale;

  const sortingOptionInMatchedLocale =
    selectedLocale?.language === 'ZH_TW' ? sortingOptionsZH : sortingOptions;

  const selectedSortingOption = sortingOptionInMatchedLocale?.find(
    (o) => o.value === 'manual',
  );
  const location = useLocation();
  const params = React.useMemo(
    () => new URLSearchParams(location.search),
    [location.search],
  );
  const navigate = useNavigate();

  return (
    <Select.Root
      value={'manual'}
      onValueChange={(value) => {
        const selectedOption = sortingOptionInMatchedLocale?.find(
          (o) => o.value === value,
        );
        if (selectedOption) {
          params.set('sort', selectedOption.value);
          navigate(`${location.pathname}?${params?.toString()}`);
        }
      }}
    >
      <Select.Trigger className="SelectTrigger" aria-label="Sorting Options">
        <div className="">
          <span className="font-semibold">
            {selectedLocale?.language === 'ZH_TW' ? '排序' : 'Sort by'}:{' '}
          </span>
          <Select.Value className="text-xs text-black">
            {selectedSortingOption && selectedSortingOption?.label}
          </Select.Value>
        </div>
        <Select.Icon className="SelectIcon">
          <svg
            viewBox="0 0 24 24"
            className="w-2 rotate-180"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
          >
            <path d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z" />
          </svg>
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content className="SelectContent">
          <Select.ScrollUpButton className="SelectScrollButton">
            <svg
              viewBox="0 0 24 24"
              className="w-2"
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              clipRule="evenodd"
            >
              <path d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z" />
            </svg>
          </Select.ScrollUpButton>
          <Select.Viewport className="SelectViewport">
            {sortingOptionInMatchedLocale?.map((o) => (
              <SelectItem
                key={`sorting-${o.value}`}
                value={o.value}
                className="text-black"
              >
                {o.label}
              </SelectItem>
            ))}
          </Select.Viewport>
          <Select.ScrollDownButton className="SelectScrollButton">
            <svg
              viewBox="0 0 24 24"
              className="w-2 rotate-180"
              xmlns="http://www.w3.org/2000/svg"
              fillRule="evenodd"
              clipRule="evenodd"
            >
              <path d="M23.245 20l-11.245-14.374-11.219 14.374-.781-.619 12-15.381 12 15.391-.755.609z" />
            </svg>
          </Select.ScrollDownButton>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
}

const SelectItem = ({
  children,
  className,
  value,
}: {
  children: React.ReactNode;
  className?: string;
  value: string;
}) => {
  return (
    <Select.Item className={clsx('SelectItem', className)} value={value}>
      <Select.ItemText>{children}</Select.ItemText>
      <Select.ItemIndicator className="SelectItemIndicator">
        <svg
          viewBox="0 0 24 24"
          className="w-3 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <path d="M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z" />
        </svg>
      </Select.ItemIndicator>
    </Select.Item>
  );
};
